import { useCallback, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Cursor } from "@/components/Cursor";
import { Intro } from "@/components/Intro";
import { Navbar } from "@/components/Navbar";
import { Marquee } from "@/components/Marquee";
import { Hero } from "@/sections/Hero";
import { PainPoints } from "@/sections/PainPoints";
import { Manifesto } from "@/sections/Manifesto";
import { Services } from "@/sections/Services";
import { Audience } from "@/sections/Audience";
import { Portfolio } from "@/sections/Portfolio";
import { Transform } from "@/sections/Transform";
import { Process } from "@/sections/Process";
import { WhyUs } from "@/sections/WhyUs";
import { About } from "@/sections/About";
import { TickerStrip } from "@/components/TickerStrip";
import { CTA } from "@/sections/CTA";
import { Testimonials } from "@/sections/Testimonials";
import { Contact } from "@/sections/Contact";
import { Footer } from "@/sections/Footer";

const MARQUEE_ITEMS = [
    "Your Vision. Online.",
    "Web Design",
    "Ministries",
    "Businesses",
    "Entrepreneurs",
    "Creators",
    "Brands",
    "Events",
];

function App() {
    const [introDone, setIntroDone] = useState(false);
    useLenis();
    const handleIntroDone = useCallback(() => setIntroDone(true), []);

    return (
        <div className="App min-h-screen bg-[#F7F9FC] text-[#0A0F1D]">
            <div className="noise-overlay" aria-hidden="true" />
            <Cursor />
            <Intro onDone={handleIntroDone} />
            <Navbar />
            <main>
                <Hero play={introDone} />
                <Marquee items={MARQUEE_ITEMS} />
                <PainPoints />
                <Manifesto />
                <Services />
                <Audience />
                <Portfolio />
                <Transform />
                <Process />
                <WhyUs />
                <About />
                <TickerStrip />
                <CTA />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid rgba(10,15,29,0.1)", color: "#0A0F1D" } }} />
        </div>
    );
}

export default App;
